
// Initialize SWYM
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

let swat;
let sectionId;
let elements;

// Main initialization function
function initializeSwymElements() {
    const wishlistElement = document.querySelector('.swymcs-custom-wishlist');
    if (!wishlistElement) {
        console.warn('Wishlist element not found, retrying...');
        setTimeout(initializeSwymElements, 1000);
        return;
    }

    elements = {
        container: wishlistElement.querySelector('#swymcs-wishlist-container'),
        listOptions: wishlistElement.querySelector('#swymcs-wishlist-list-options-container'),
        itemsContainer: wishlistElement.querySelector('#swymcs-wishlist-items-container'),
        emptyContainer: wishlistElement.querySelector('#swymcs-empty-wishlist-container'),
    };

    return true;
}

function initSwymUI(swatInstance) {
    if (!window._swat) {
        console.warn('SWYM not initialized, retrying...');
        setTimeout(() => initSwymUI(swatInstance), 1000);
        return;
    }

    swat = swatInstance;
    
    if (!initializeSwymElements()) {
        return;
    }

    fetchWishlist();

    // Set up event listeners
    const accountIcon = document.querySelector('.thb-secondary-area-item.my-account');
    if (accountIcon) {
        accountIcon.addEventListener('click', () => {
            fetchWishlist();
        });
    }
}

function fetchWishlist() {
    swat.fetchLists({
        callbackFn: (lists) => {
            lists = lists.reverse();
            const selectedList = lists[0];
            
            const currentListId = swat.swymCustomWishlistSelectedListId || lists[0]?.lid;
            swat.swymCustomWishlistSelectedListId = currentListId;

            renderList(selectedList.listcontents);
        },
        errorFn: (error) => console.error('Error while fetching all Lists', error),
    });
}


async function renderList(list) {
    const wishlistElement = document.querySelector('.swymcs-custom-wishlist');
    if (wishlistElement && elements && elements.itemsContainer) {
        elements.itemsContainer.innerHTML = '';
        list.forEach(renderWishlistItem);
        updateUIState(list);
    }
}

const REMOVE_ICON_SVG = '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2L15.09 8.58255L22 9.64458L17 14.7655L18.18 22L12 18.5825L5.82 22L7 14.7655L2 9.64458L8.91 8.58255L12 2Z" stroke="black" style="stroke:black;stroke-opacity:1" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

function renderWishlistItem(item) {
    const title = item.dt || '';
    const url = item.du || '';
    const productImage = item.productData?.featured_image || item.iu || '';
    const handle = item.du ? item.du.split('/products/')[1]?.split('?')[0] : null;

    const wishlistItem = document.createElement('div');
    wishlistItem.className = 'swymcs-wishlistplus-item';
    wishlistItem.dataset.epi = item.epi;
    wishlistItem.dataset.empi = item.empi;
    wishlistItem.dataset.du = url;
    wishlistItem.dataset.sectionid = sectionId;

    const imageLink = document.createElement('a');
    imageLink.className = 'swymcs-wishlist-image-container';
    imageLink.href = url;
    const img = document.createElement('img');
    img.className = 'swymcs-wishlistplus-item-image';
    img.src = productImage;
    img.alt = '';
    imageLink.appendChild(img);

    const content = document.createElement('div');
    content.className = 'swymcs-wishlistplus-item-content';
    const titleLink = document.createElement('a');
    titleLink.className = 'swymcs-wishlistplus-item-title';
    titleLink.href = url;
    const titleContent = document.createElement('div');
    titleContent.className = 'swymcs-wishlistplus-item-title-content';
    titleContent.textContent = title;
    titleLink.appendChild(titleContent);
    const priceEl = document.createElement('div');
    priceEl.className = 'swymcs-product-final-price';
    priceEl.setAttribute('aria-live', 'polite');
    content.appendChild(titleLink);
    content.appendChild(priceEl);

    const removeBtn = document.createElement('button');
    removeBtn.className = 'swymcs-remove-productBtn swymcs-wishlistplus-item-remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + title + ' from wishlist');
    removeBtn.innerHTML = REMOVE_ICON_SVG;

    wishlistItem.appendChild(imageLink);
    wishlistItem.appendChild(content);
    wishlistItem.appendChild(removeBtn);

    if (handle) {
        fetch('/products/' + handle + '.js')
            .then(function(res) { return res.json(); })
            .then(function(productData) {
                if (productData.variants) {
                    var variant = productData.variants.find(function(v) { return v.id.toString() === item.epi?.toString(); });
                    var price = variant ? variant.price : productData.price;
                    priceEl.textContent = bassike.formatSwymPrice(price);
                }
            })
            .catch(function() {
                priceEl.textContent = bassike.formatSwymFallbackPrice(item.pr);
            });
    }

    removeBtn.addEventListener('click', () => {
        const product = {
            epi: item.epi,
            empi: item.empi,
            du: item.du
        };
        _swat.deleteFromList(
            _swat.swymCustomWishlistSelectedListId,
            product,
            () => {
                fetchWishlist();
            },
            (error) => console.error('Failed to remove from wishlist', error)
        );
    });


    const wishlistElement = document.querySelector('.swymcs-custom-wishlist');
    if (wishlistElement && elements && elements.itemsContainer) {
        elements.itemsContainer.appendChild(wishlistItem);
    }
}

function updateUIState(wishlist) {
    const wishlistElement = document.querySelector('.swymcs-custom-wishlist');
    if (wishlistElement) {
        if (wishlist.length > 0) {
            elements.container.classList.remove('swymcs-hide-container');
            elements.emptyContainer.classList.add('swymcs-hide-container');
        } else {
            elements.emptyContainer.classList.remove('swymcs-hide-container');
            elements.container.classList.add('swymcs-hide-container');
        }
    }
}

// Add initialization function to SWYM callbacks
window.SwymCallbacks.push(initSwymUI);

// Start initialization process when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    if (window._swat) {
        initSwymUI(window._swat);
    } else {
        console.warn('Waiting for SWYM to be available...');
        const checkSwym = setInterval(() => {
            if (window._swat) {
                clearInterval(checkSwym);
                initSwymUI(window._swat);
            }
        }, 1000);
    }
});